import PrizeTypeSelect from "./prizeTypeSelect.container";

export default PrizeTypeSelect;
